import React from "react";
import { Linkedin, Mail } from "lucide-react";

function App() {
  return (
    <div className="min-h-screen bg-[#0a0a0a] text-white flex flex-col font-sans selection:bg-white/20">
      {/* Header */}
      <header className="flex justify-between items-center p-6 md:p-10">
        <div className="text-sm font-bold tracking-[0.2em] uppercase">
          Metavellum
        </div>
      </header>

      {/* Main Content */}
      <main className="flex-1 flex flex-col justify-center px-6 md:px-12 max-w-5xl mx-auto w-full mt-[-5vh]">
        <div className="inline-flex items-center gap-2 bg-white/5 border border-white/10 px-3 py-1.5 rounded-full text-[10px] font-bold tracking-widest text-gray-400 mb-8 w-fit uppercase">
          <span className="w-1.5 h-1.5 rounded-full bg-gray-400"></span>
          Project Paused
        </div>
        
        <h1 className="text-5xl md:text-7xl font-bold mb-6 tracking-tight text-[#f3f4f6]">
          Metavellum is on pause.
        </h1>
        
        <p className="text-gray-400 text-lg md:text-xl max-w-2xl leading-relaxed">
          We are stepping back from active development while we re-evaluate the path forward. Thank you to everyone who supported the mission so far. For inquiries, please reach out directly.
        </p>
      </main>

      {/* Bottom Footer */}
      <footer className="flex justify-between items-center p-6 md:p-10 border-t border-white/10 text-gray-500 text-xs md:text-sm mt-auto">
        <div>
          Metavellum · Munich · 2026
        </div>
        <div className="flex items-center gap-6">
          <a href="https://linkedin.com/company/metavellum" target="_blank" rel="noreferrer" className="hover:text-white transition-colors">
            <Linkedin size={18} strokeWidth={1.5} />
          </a>
          <a href="mailto:anna.radova@metavellum.com" className="hover:text-white transition-colors">
            <Mail size={18} strokeWidth={1.5} />
          </a>
        </div>
      </footer>
    </div>
  );
}

export default App;
